var React = require('react');

function ArrowIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.39349 6.1481C4.0355 5.79012 4.0355 5.20972 4.39349 4.85174C4.75147 4.49376 5.33187 4.49376 5.68985 4.85174L11.1898 10.3517C11.5369 10.6988 11.549 11.2576 11.2174 11.6193L6.17573 17.1193C5.83363 17.4925 5.25378 17.5177 4.88059 17.1756C4.50739 16.8335 4.48218 16.2537 4.82428 15.8805L9.27287 11.0275L4.39349 6.1481Z","fill":"inherit","key":0}),React.createElement("path",{"opacity":"0.3","d":"M10.8102 6.1481C10.4522 5.79012 10.4522 5.20972 10.8102 4.85174C11.1681 4.49376 11.7485 4.49376 12.1065 4.85174L17.6065 10.3517C17.9535 10.6988 17.9657 11.2576 17.6341 11.6193L12.5924 17.1193C12.2503 17.4925 11.6704 17.5177 11.2973 17.1756C10.9241 16.8335 10.8988 16.2537 11.2409 15.8805L15.6895 11.0275L10.8102 6.1481Z","fill":"inherit","key":1})]);
}

ArrowIcon.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = ArrowIcon;

ArrowIcon.default = ArrowIcon;
